import useActions from '@pages/lending/hooks/useActions';
import ACTIONS from '@pages/lending/types/actionsEnum.type';
import Accept from './ActionModal/ActionModal';
import Header from './Header/Header';
import LendingInfo from './LendingInfo/LendingInfo';

const Exporter = () => {
  const { userAction, setUserAction } = useActions();
  return (
    <div className="p-5">
      <Header />
      <LendingInfo
        onAccept={() => setUserAction(ACTIONS.ACCEPT)}
        onReject={() => setUserAction(ACTIONS.REJECT)}
      />
      <Accept
        actionType={userAction || ACTIONS.ACCEPT}
        open={!!userAction}
        onCancel={() => setUserAction(undefined)}
        onAccept={() => {}}
        onReject={() => {}}
      />
    </div>
  );
};

export default Exporter;
